<template>
    <div class="newPage">
        <div class="content">
            <div class="VOCNavBar">
                <div class="title">参数选择</div>
                <div class="navBarItem">
                    <div class="navBarTitle">开始日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.startTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">结束日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.endTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">数据类型</div>
                    <div class="navBarValue">
                        <el-radio-group v-model="queryParams.type">
                            <el-radio :label="0">原始</el-radio>
                            <el-radio :label="1">审核</el-radio>
                            <el-radio :label="2">全部</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">查询类型</div>
                    <div class="navBarValue">
                        <el-radio-group v-model="queryParams.rateType">
                            <el-radio :label="1">污染物</el-radio>
                            <el-radio :label="2">站点</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="title">选择站点</div>
                <div class="statisticBox">
                    <el-checkbox-group v-model="queryParams.stations">
                        <div v-for="(item,index) in addressList" :key="index">
                            <el-checkbox :label='item'>{{item}}</el-checkbox>
                        </div>
                    </el-checkbox-group>

                </div>
                <div class="btnBox">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="getList">查询</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="excelExport">导出</el-button>
                </div>
            </div>
            <div class="showContent">
                <breadcrumb></breadcrumb>
                <div class="VOCContent" v-if="tableData">
                    <el-table
                            size="mini"
                            :data="tableData.list"
                            border
                            style="width: 100%">
                        <el-table-column
                                prop="name"
                                label="名称"
                                width="120">
                        </el-table-column>
                        <el-table-column prop="value" label="有值数"></el-table-column>
                        <el-table-column prop="nullValue" label="空值数"></el-table-column>
                        <el-table-column prop="zeroValue" label="0值数"></el-table-column>
                        <el-table-column prop="valueRate" label="有值率"></el-table-column>
                        <el-table-column prop="nullRate" label="空值率"></el-table-column>
                        <el-table-column prop="zeroRate" label="0值率"></el-table-column>
                        <el-table-column prop="count" label="总数"></el-table-column>
                    </el-table>

                    <pagination
                            v-show="tableData.totalCount>0"
                            :total="tableData.totalCount"
                            :page.sync="queryParams.page"
                            :limit.sync="queryParams.pageSize"
                            @pagination="getList"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Breadcrumb from "../../../components/breadcrumb";

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }


    import url from "../../../utils/UrlApi"

    export default {
        name: "effectiveData",
        components: {Breadcrumb},
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                queryParams: {
                    rateType: 1,
                    stations: [],
                    voc: '',
                    type: 1,
                    page: 1,
                    pageSize: 10
                },
                addressList: [],
                tableData: null,
                queryList: []
            }
        },
        created() {
            // this.getList()
            this.getParams()
        },
        methods: {
            getParams() {
                let data = {}
                this.$http.get(url.getSelectUse, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.getaddresstree()
                        if (res.data.data) {
                            let data = res.data.data
                            data.stations = data.stations.split(',')
                            data.rateType = 1
                            this.queryParams = data
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getList() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.stations = this.queryParams.stations.join()

                if (!data.rateType) {
                    return this.$message.error('请选择查询类型')
                }


                this.$http.get(url.vocDataRate, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.tableData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            //  获取 站点数据
            getaddresstree() {
                let data = {}
                this.$http.get(url.vocDataAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        console.log(res)
                        this.addressList = res.data.data
                        this.getList()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  导出
            excelExport() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.token = localStorage.getItem('token')
                data.stations = this.queryParams.stations.join()
                let allUrl = url.vocrateExport + params(data)
                window.open(allUrl, '_blank')
            },
        }
    }
</script>

<style scoped lang="less">
    @import "../../../assets/vocContent";
</style>